import React, { lazy, Suspense } from "react";
// import Service from "./views/Service";

import { Route, Routes } from "react-router-dom";
import Kids from "./views/Kids.js";
import Women from "./views/Women.js";
import NewArrivalsPage from "./views/NewArrivalsPage.js";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import SecondNavbar from "./components/SecondNavbar";
import SkltonPage from "./components/SkltonPage.jsx";

const Men = React.lazy(() => import("./views/Men"));

function App() {
  return (
    <>
      <Suspense fallback={<SkltonPage/>}>
        <Header />
        <Navbar />
        <SecondNavbar />
        <Routes>
          <Route exact path="/" element={<Kids />} />
          <Route path="Men" element={<Men />} />
          <Route path="Women" element={<Women />} />
          <Route path="NewArrival" element={<NewArrivalsPage />} />
          <Route path="/Men/NewArrival" element={<NewArrivalsPage />} />
          <Route path="/Women/NewArrival" element={<NewArrivalsPage />} />
        </Routes>
      </Suspense>
      {/* <Service/> */}
      {/* <SkltonPage/> */}
    </>
  );
}

export default App;
